import React from "react";
import { GatsbyImage, StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

export const CustomLink = ({ data, children }) => {
  if (data.linkType === "url") {
    return (
      <a
        href={data.url}
        target="_blank"
        key={data.id}
        aria-label={data.name}
        className="relative group aspect-square overflow-hidden "
      >
        {children}
      </a>
    );
  } else {
    return (
      <Link
        to={data.slug.current}
        target="_blank"
        key={data.id}
        className="relative group aspect-square overflow-hidden "
      >
        {children}
      </Link>
    );
  }
};
const Menu = ({ data }) => {
  return (
    <div className="w-full px-5 sm:px-10 py-5 sm:py-10" id={data.sectionId}>
      <div className="max-w-7xl w-full mx-auto space-y-3">
        <h2 className="text-center text-2xl sm:text-4xl font-bold flex items-center justify-center">
          {data.leftIcon && (
            <img
              src={data.leftIcon.asset.url || "/placeholder.svg"}
              alt=""
              className="w-9 sm:w-12 h-9 sm:h-12 mr-2 object-contain"
            />
          )}
          {data.title}
          {data.rightIcon && (
            <img
              src={data.rightIcon.asset.url || "/placeholder.svg"}
              alt=""
              className="w-9 sm:w-12 h-9 sm:h-12 ml-2 object-contain"
            />
          )}
        </h2>
        <p className="text-center text-lg sm:text-xl max-w-3xl mx-auto">
          {data.subTitle}
        </p>
        <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-3 sm:gap-y-5">
          {data.categories.map((category) => (
            <CustomLink
              data={category}
              //   onMouseEnter={() => setHoveredCategory(category.id)}
              //   onMouseLeave={() => setHoveredCategory(null)}
            >
              <div className="rounded-lg overflow-hidden p-3">
                <GatsbyImage
                  image={category.firstImage.asset.gatsbyImageData}
                  alt={category.name}
                  objectFit="cover"
                  className={`transition-opacity duration-300 ease-linear aspect-square rounded-lg`}
                />
              </div>
              <div className="absolute -bottom-full w-full h-full transition-all duration-200 p-4 ease-linear group-hover:bottom-0 aspect-square bg-white rounded-lg">
                <div
                  className="relative w-full h-full flex flex-col items-center justify-center shadow-primary/50 rounded-lg"
                  style={{
                    boxShadow: "0 0 8px #2a8530",
                  }}
                >
                  <h2 className="text-2xl font-bold">{category.name}</h2>
                  <h3 className="text-lg font-medium mb-0 text-black/45">
                    {category.subtitle}
                  </h3>
                  <div className="absolute -top-4 left-1/2 -translate-x-1/2 z-10">
                    <StaticImage
                      src="../../../../static/logo.png"
                      alt="Simply Salad"
                      width={50}
                      height={50}
                      objectFit="contain"
                      className="w-full h-full rounded-full object-contain"
                    />
                  </div>
                  <div className="w-[50%] h-[50%] rounded-full overflow-hidden">
                    <GatsbyImage
                      image={category.secondImage.asset.gatsbyImageData}
                      alt={category.name}
                      objectFit="cover"
                      className={`w-full h-full object-cover`}
                    />
                  </div>
                </div>
              </div>
              {/* <div className="text-center py-2">
                <h2 className="text-2xl font-bold font-sometimesfamily">
                  {category.name}
                </h2>
                <h3 className="text-xl font-medium text-black/45">
                  {category.subtitle}
                </h3>
                <span className="opacity-0 group-hover:opacity-100 transition-all duration-300 ease-linear text-lg mt-2 font-bold text-secondary">
                  Order Now
                </span>
              </div> */}
            </CustomLink>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Menu;
